<script setup lang="ts">
  import { isVNode } from 'vue'
  import { useToast } from './useToast'
  import Toast from './Toast.vue'
  import ToastClose from './ToastClose.vue'
  import ToastDescription from './ToastDescription.vue'
  import ToastProvider from './ToastProvider.vue'
  import ToastTitle from './ToastTitle.vue'
  import ToastViewport from './ToastViewport.vue'

  const { toasts } = useToast()
</script>

<template>
  <ToastProvider>
    <Toast v-for="toast in toasts" :key="toast.id" v-bind="toast">
      <div class="grid gap-1">
        <div class="flex items-center gap-1">
          <component
            :is="toast.icon"
            v-if="toast.icon"
            class="lucide-icon size-4 shrink-0"
          />
          <ToastTitle v-if="toast.title">
            {{ toast.title }}
          </ToastTitle>
        </div>
        <template v-if="toast.description">
          <ToastDescription v-if="isVNode(toast.description)">
            <component :is="toast.description" />
          </ToastDescription>
          <ToastDescription v-else>
            {{ toast.description }}
          </ToastDescription>
        </template>
        <ToastClose />
      </div>
      <component :is="toast.action" />
    </Toast>
    <ToastViewport />
  </ToastProvider>
</template>
